import type {
  ContractAgreement,
  CreateAccountCredentials,
  Credentials,
} from '../models/credentials';

type ApiCredentials = {
  usernameOrEmail: string;
  password: string;
};

type ApiCreateAccountPayload = {
  username: string | undefined;
  email: string;
  password: string;
  allowMarketing?: boolean;
  contract_agreements: ContractAgreement[];
};

type ApiUserExists = {
  exists: boolean;
};

type TokenValid = {
  valid: boolean;
};

type ResetSuccessful = {
  success: boolean;
};

type FetchUserExistsOpts =
  | string // string will result in being treating as an email
  | { email: string }
  | { username: string };

export const toApiCredentials = ({ email, password }: Credentials): ApiCredentials => ({
  usernameOrEmail: email,
  password,
});

export const toCreateAccountPayload = ({
  username,
  email,
  password,
  allowMarketing,
  contract_agreements,
}: CreateAccountCredentials): ApiCreateAccountPayload => ({
  username,
  email,
  password,
  allowMarketing: allowMarketing,
  contract_agreements: contract_agreements || [],
});

// If opts is passed a string it is assumed it's an email
export const toUserExistsQuery = (opts: FetchUserExistsOpts) =>
  typeof opts === 'string' ? { email: opts } : opts;

export const doesUserExist = ({ exists }: ApiUserExists): boolean => Boolean(exists);

export const isValid = ({ valid }: TokenValid): boolean => Boolean(valid);

export const resetSuccess = ({ success }: ResetSuccessful): boolean => Boolean(success);
